export const getArtistWizardRoute = () => '/artist-wizard';